import { Rotate3d } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { selectedToolState } from '~/state/atoms/toolsAtoms';

/**
 * Arms the free rotation: a drag on a tile turns the plane views of that
 * tile's image together.
 */
export default function RotateViewTool() {
    const [tool, setTool] = useRecoilState(selectedToolState);
    const intl = useIntl();

    const isSelected = tool === 'rotateView';

    return (
        <ToolbarButton
            icon={<Rotate3d />}
            tooltip={intl.formatMessage({ id: 'toolbar.rotateView.tooltip' })}
            selected={isSelected}
            onClick={() => setTool(isSelected ? 'pan' : 'rotateView')}
            data-testid="tool-rotate-view"
        />
    );
}
